type SearchTermAction =
  | { type: "SET_SEARCH_TERM"; payload: string }
  | { type: "CLEAR_SEARCH_TERM" };

const searchTerm = (state: string = "", action: SearchTermAction): string => {
  switch (action.type) {
    case "SET_SEARCH_TERM":
      return action.payload;
    case "CLEAR_SEARCH_TERM":
      return "";
    default:
      return state;
  }
};

export default searchTerm;
